'use strict';

var isPrototypeOf = require('../../internals/object-is-prototype-of');
var method = require('../array/virtual/index-of');
var ArrayPrototype = Array.prototype;
module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || isPrototypeOf(ArrayPrototype, it) && own === ArrayPrototype.indexOf ? method : own;
};